import { Component, signal, inject, input } from '@angular/core';
import { AssetDetailTabs } from './types';
import { Breadcrumb } from '../shared/breadcrumb/breadcrumb';
import { Breadcrumbs } from '../shared/breadcrumb/types';
import { AssetDetailSidebar } from './asset-detail-sidebar/asset-detail-sidebar';
import { AssetDetailHeader } from './asset-detail-header/asset-detail-header';
import { AssetDetailContent } from './asset-detail-content/asset-detail-content';
import { AssetService } from '../services/asset-service/asset.service';
import { Loader } from '../shared/loader';

@Component({
  selector: 'asset-detail-page',
  imports: [Breadcrumb, AssetDetailSidebar, AssetDetailHeader, AssetDetailContent, Loader],
  templateUrl: './asset-detail-page.html',
  styleUrl: './asset-detail-page.scss',
})
export class AssetDetailPage {
  assetService = inject(AssetService);
  readonly assetId = input<string>();

  assetResource = this.assetService.getAssetDetail(this.assetId);

  tabsStuck = signal(false);

  activeTab = signal<AssetDetailTabs>('overview');

  readonly breadcrumbLinks: Breadcrumbs = [
    {
      title: 'Home',
      href: '/home',
    },
    {
      title: 'Asset Catalog',
      href: '/catalog',
    },
    {
      title: this.assetResource?.value()?.asset_name ?? '',
    },
  ];

  snackbarVisible = signal(false);

  // ── Request Access modal ──────────────────────────────────────────────────
  requestAccessModalOpen = signal(false);
  requestReason = signal('');
  requestSubmitted = signal(false);
  private requestSnackTimer: ReturnType<typeof setTimeout> | null = null;

  setTab(tab: 'overview' | 'source' | 'technical'): void {
    this.activeTab.set(tab);
  }

  closeRequestAccessModal(): void {
    this.requestAccessModalOpen.set(false);
  }

  submitAccessRequest(): void {
    this.requestAccessModalOpen.set(false);
    if (this.requestSnackTimer) clearTimeout(this.requestSnackTimer);
    this.requestSubmitted.set(true);
    this.requestSnackTimer = setTimeout(() => this.requestSubmitted.set(false), 5000);
  }
}
